export default __webpack_public_path__ + "static/media/readbook_color.00ae1fde.png";